import { css, cx } from '@emotion/css';
import React, { useEffect, useState } from 'react';
import { mqBreakpoints, MAX_DESKTOP_WIDTH_REM } from '../../system-libraries/styles';
import { pxToRem } from '../../system-libraries/styles/utils';
import RedirectUtils from '../../system-utils/redirect-utils';
import { NavTabData } from '../../system-utils/redirect-utils/types';
import Config from '../../system-utils/config-manager';

export const TabNav: React.FC = () => {
  const buttons = Config.get<NavTabData[]>('tabs', []);
  const [activeButtonIndex, setActiveButtonIndex] = useState<number>(-1);

  useEffect(() => {
    for (let i = 0; i < buttons.length; i++) {
      if (validatePage(buttons[i].path)) {
        setActiveButtonIndex(i);
      }
    }
  }, []);

  const validatePage = (url: string) => {
    return window.location.href.indexOf(url) > -1;
  };

  const onTabNavClick = (id: number) => {
    RedirectUtils.initiateRedirectFromNavTab(id);
    setActiveButtonIndex(buttons.findIndex(item => item.id === id));
  };

  const Icon = props => {
    const { button, selected } = props;
    let img = Config.get('image_cdn_base_url') + '/ui/shared-component-webapp/tab-nav';

    if (button.title === 'Track') {
      img += '/track';
    } else if (button.title === 'Connect') {
      img += '/connect';
    } else if (button.title === 'Explore') {
      img += '/explore';
    } else if (button.title === 'Marketplace') {
      img += '/marketplace';
    }

    img += selected ? '_selected.svg' : '.svg';

    return <img src={img} className={styles.logoImage} data-testid={`tab-nav-img-${button.title}`} />;
  };

  return (
    <div className={styles.tabNav} data-testid='nba-tabnav'>
      <div className={styles.container}>
        <div className={styles.buttonsContainer}>
          {buttons.map((item, index) => (
            <button key={index.toString()} tabIndex={0} onClick={() => onTabNavClick(item.id)} className={cx(styles.button, { [styles.buttonActive]: activeButtonIndex === index })} data-testid='nba-tabnav--item'>
              <Icon button={item} selected={activeButtonIndex === index} />
              <div className={styles.buttonName}>{item.title}</div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

const styles = {
  tabNav: css({
    backgroundColor: 'var(--color-white)',
    boxShadow: 'inset 0 1px 0 0 var(--color-border)',
    flexShrink: 0,
    height: pxToRem(80),
    margin: '0 auto',
    position: 'fixed',
    bottom: 0,
    width: '100%',
    zIndex: 100,

    [mqBreakpoints.desktop]: {
      boxShadow: 'inset 0 -1px 0 0 var(--color-border)',
      position: 'sticky',
      top: 0,
    },
  }),
  container: css({
    margin: '0 auto',
    color: 'var(--color-black)',
    fontSize: pxToRem(18),
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    maxWidth: MAX_DESKTOP_WIDTH_REM,
  }),
  buttonsContainer: css({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
  }),
  button: css({
    background: 'transparent',
    border: 'none',
    height: '100%',
    width: pxToRem(82),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    alignItems: 'center',
    cursor: 'pointer',

    [mqBreakpoints.desktop]: {
      width: pxToRem(248),
    },
  }),
  buttonActive: css({
    color: 'var(--color-primary)',
    boxShadow: 'inset 0 2px 0 0 var(--color-primary)',

    [mqBreakpoints.desktop]: {
      boxShadow: 'inset 0 -2px 0 0 var(--color-primary)',
    },
  }),
  buttonName: css({
    fontFamily: 'var(--font-heading)',
    fontWeight: 'var(--font-weight-medium)',
    textAlign: 'center',
    marginBottom: pxToRem(16),
    fontSize: pxToRem(11),
    lineHeight: pxToRem(16),

    [mqBreakpoints.desktop]: {
      fontSize: pxToRem(18),
      lineHeight: pxToRem(24),
      marginBottom: pxToRem(22),
    },
  }),
  logoImage: css({
    width: pxToRem(22),
    height: pxToRem(22),
    marginBottom: pxToRem(8),

    [mqBreakpoints.desktop]: {
      display: 'none',
    },
  }),
};
